// Browsers
export const CHROME_BROWSER = 'chrome'
export const EDGE_BROWSER = 'edge'
export const FIREFOX_BROWSER = 'firefox'
export const SAFARI_BROWSER = 'safari'
export const UNSUPPORTED_BROWSER = 'other'

// localStorage keys
export const STORAGE_NEW_USER_IS_TAB_V4_BETA = 'tab.newUser.isTabV4Enabled'
export const STORAGE_REFERRAL_DATA_REFERRING_CAMPAIGN =
  'tab.referralData.referringCampaign'
export const STORAGE_REFERRAL_DATA_REFERRING_USER =
  'tab.referralData.referringUser'
export const STORAGE_REFERRAL_DATA_REFERRING_CHANNEL =
  'tab.referralData.referringChannel'
export const STORAGE_REFERRAL_DATA_MISSION_ID = 'tab.referralData.missionId'
export const SEARCH_STORAGE_REFERRAL_DATA_REFERRING_USER =
  'search.referralData.referringUser'
export const SEARCH_STORAGE_REFERRAL_DATA_REFERRING_CHANNEL =
  'search.referralData.referringChannel'
export const STORAGE_NEW_USER_CAUSE_ID = 'tab.newUser.causeId'
export const STORAGE_CATS_CAUSE_ID = 'CA6A5C2uj'
export const STORAGE_SEAS_CAUSE_ID = 'SGa6zohkY'
export const KEY_WORDS =
  'charity, extension, new tab, chrome, help, donation, raise money, money, easy, ways to donate, free, best, home, youtube, safe, volunteer, internet, tab for a cause, impact, legitimate, food, facebook, twitter, reddit, instagram, tumblr, '

// Mobile app link
export const MOBILE_APP_REDIRECT_URL = 'https://azy26.app.link'

// Mobile app store URLs
export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=io.gladly.appforacause'
export const APPLE_APP_STORE_URL =
  'https://apps.apple.com/gb/app/app-for-a-cause/id6740837141?uo=2'
